import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon, PhoneIcon, MessageCircleIcon } from 'lucide-react';
import { CONTACT } from '../data/copy';
import { useLanguage } from '../contexts/LanguageContext';
export function Faq() {
  const {
    t
  } = useLanguage();
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="w-full bg-white py-20 lg:py-28" data-id="element-71" data-mp="2e0fypu1ny239">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-72" data-mp="2dzxwmgsbktnf">
        <div className="max-w-2xl" data-id="element-73" data-mp="290tnfq5eavx3">
          <h2 className="font-display text-3xl font-black tracking-tight text-forest sm:text-4xl lg:text-5xl" data-id="element-74" data-mp="291wcdsj5qoad">
            {t.faq.title}
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-neutral-600" data-id="element-75" data-mp="1z3ff6dtmldfv">
            {t.faq.intro}
          </p>
        </div>

        <div className="mt-12 grid gap-10 lg:grid-cols-[minmax(0,1.5fr)_minmax(0,1fr)] lg:gap-14" data-id="element-76" data-mp="so64eaox3fvg">
          <div className="border-t border-neutral-200" data-id="element-77" data-mp="nmyvu9eyacnq">
            {t.faq.items.map((item, index) => {
            const open = openIndex === index;
            return <div key={item.question} className="border-b border-neutral-200" data-id="element-78" data-mp="uhkdrr8ofe1n" data-mpi={index}>
                  <h3 data-id="element-79" data-mp="fjry8z34qpng">
                    <button type="button" onClick={() => setOpenIndex(open ? null : index)} aria-expanded={open} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 py-5 text-left" data-id="element-80" data-mp="fkjm1nqhjj36">
                      <span className={`font-display text-base font-bold transition-colors duration-150 ease-out sm:text-lg ${open ? 'text-rust' : 'text-forest hover:text-rust'}`} data-id="element-81" data-mp="bjzpal9tqhhk">
                        {item.question}
                      </span>
                      <PlusIcon className={`mt-0.5 h-5 w-5 shrink-0 text-rust transition-transform duration-200 ease-out ${open ? 'rotate-45' : 'rotate-0'}`} aria-hidden="true" data-id="element-82" data-mp="3nyig2jtwcue1" />
                    </button>
                  </h3>

                  <AnimatePresence initial={false} data-id="element-83" data-mp="1koovgou0zycf">
                    {open && <motion.div id={`faq-panel-${index}`} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.25,
                  ease: [0.23, 1, 0.32, 1]
                }} className="overflow-hidden" data-id="element-84" data-mp="1fpvgst3061ao">
                        <p className="max-w-2xl pb-6 pr-10 text-[15px] leading-relaxed text-neutral-600" data-id="element-85" data-mp="s09hm5mmrm2o">
                          {item.answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>

          <aside className="h-fit rounded-lg bg-forest p-8 lg:sticky lg:top-28" data-id="element-86" data-mp="38p2f785frenu">
            <h3 className="font-display text-xl font-bold text-white" data-id="element-87" data-mp="38mzdvryu1z3t">
              {t.faq.ctaTitle}
            </h3>
            <p className="mt-3 text-[15px] leading-relaxed text-white/75" data-id="element-88" data-mp="3ievno0aa7dnv">
              {t.faq.ctaBody}
            </p>
            <div className="mt-7 flex flex-col gap-3" data-id="element-89" data-mp="3ncx56gs274x8">
              <a href={CONTACT.phoneHref} className="inline-flex items-center justify-center gap-2.5 rounded-md bg-rust px-5 py-3.5 text-center font-display text-sm font-bold text-white transition-colors duration-150 ease-out hover:bg-rust-dark" data-id="element-90" data-mp="3nfjh0slzg6l9">
                <PhoneIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-91" data-mp="1x3n8awho9y32" />
                {t.faq.ctaCall}
              </a>
              <a href={CONTACT.whatsappHref} target="_blank" rel="noreferrer" className="inline-flex items-center justify-center gap-2.5 rounded-md border-2 border-white/70 px-5 py-3 text-center font-display text-sm font-bold text-white transition-colors duration-150 ease-out hover:border-white hover:bg-white hover:text-forest" data-id="element-92" data-mp="16pxebln5kgdq">
                <MessageCircleIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-93" data-mp="nywekve7kgt4" />
                {t.faq.ctaWhatsapp}
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>;
}